export const CONTACT_COMMUNICATION_EVENT = "rpo:contact-communication";

export function contactCallHref(value = "") {
  const raw = String(value).trim().replace(/^tel:/i, "");
  if (!/^[+\d\s().-]+(?:\s*(?:x|ext\.?)\s*\d+)?$/i.test(raw)) return "";
  const [number, extension] = raw.split(/\s*(?:x|ext\.?)\s*/i);
  const digits = number.replace(/[^\d+]/g, "");
  if (!/^\+?\d{5,15}$/.test(digits)) return "";
  return `tel:${digits}${extension ? `;ext=${extension}` : ""}`;
}

export function contactMessageContext(record = {}) {
  return {
    candidate_name: record.candidate_name || record.full_name || record.name || [record.first_name, record.last_name].filter(Boolean).join(" "),
    candidate_email: String(record.candidate_email || record.contact_email || record.email || record.to_email || record.email_url || "").replace(/^mailto:/i, ""),
    candidate_phone: String(record.candidate_phone || record.contact_phone || record.phone || record.phone_number || record.sms_url || "").replace(/^(?:tel|sms):/i, ""),
    candidate_title: record.candidate_title || record.title || "",
    company_name: record.company_name || record.company || "",
    job_title: record.job_title || "",
    stage: record.stage || "",
  };
}

export const openContactEmail = (record) => window.dispatchEvent(new CustomEvent(CONTACT_COMMUNICATION_EVENT, { detail: { kind: "email", message: contactMessageContext(record) } }));
export const openContactCall = (record) => window.dispatchEvent(new CustomEvent(CONTACT_COMMUNICATION_EVENT, { detail: { kind: "call", message: contactMessageContext(record) } }));

export async function communicationRequest(path, body) {
  const token = ["token", "authToken", "jwt", "accessToken", "access_token"]
    .map((key) => localStorage.getItem(key) || sessionStorage.getItem(key)).find(Boolean);
  const multipart = body instanceof FormData;
  const response = await fetch(`${String(process.env.REACT_APP_API_BASE || "").replace(/\/$/, "")}/api/${path}`, {
    method: "POST", credentials: "include",
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(!multipart ? { "Content-Type": "application/json" } : {}) },
    body: multipart ? body : JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || "Unable to complete the request. Please try again.");
  return payload;
}
